/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_KinesiotapingInputs */

const en_service_type_kinesiotaping = /** @type {(inputs: Service_Type_KinesiotapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinesiotaping`)
};

const pl_service_type_kinesiotaping = /** @type {(inputs: Service_Type_KinesiotapingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinesiotaping`)
};

/**
* | output |
* | --- |
* | "Kinesiotaping" |
*
* @param {Service_Type_KinesiotapingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_kinesiotaping = /** @type {((inputs?: Service_Type_KinesiotapingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_KinesiotapingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_kinesiotaping(inputs)
	return en_service_type_kinesiotaping(inputs)
});